import React from 'react';
import { Box } from '@mui/material';

/** Official Microsoft four-square mark (for sign-in affordance). */
const MicrosoftLogo = ({ size = 20, sx }) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21 21"
    width={size}
    height={size}
    aria-hidden
    sx={{ display: 'block', flexShrink: 0, ...sx }}
  >
    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
    <rect x="12" y="1" width="9" height="9" fill="#7fba00" />
    <rect x="1" y="12" width="9" height="9" fill="#00a4ef" />
    <rect x="12" y="12" width="9" height="9" fill="#ffb900" />
  </Box>
);

export default MicrosoftLogo;
